import React, { useState, useEffect } from "react";

import { Container } from "react-grid-system";

import FormAgronomo from "./form";

import ArrowIcon from "../../../assets/icons/icon-arrow-down-circle-gray.png";
import responsavel from '../../../assets/icons/icon-farmer-gray.png'
import ArrowIconDisabled from "../../../assets/icons/icon-arrow-disabled.svg";

import * as S from "./styles";
import { theme } from "../../../styles/theme";
import { BodyPSpan, H6, TaglineP, TaglinePSpan } from "../../../styles/stylesTypography";
import { FormContainer, Card, Title, Paragraph, RowInfo, ColInfo, Label, Texto, ContainerForm } from "./styles";

const PrescriptionStepThree = ({ ...props }) => {

    const [isOpenBox, setIsOpenBox] = useState(false);
    const [erroResp, setErroResp] = useState(false);
    const [erroCrea, setErroCrea] = useState(false);
    const [erroArt, setErroArt] = useState(false);

    const openBoxAgronomo = () => {
        setIsOpenBox(!isOpenBox);
    }

    const openBoxAgronomo2 = () => {
        if (isOpenBox === false && props.disabled === false) {
            setIsOpenBox(!isOpenBox);
        }
    }

    const updateValues = (values) => {
        props.update(values);
    }

    useEffect(() => {
        props.updateIsOpen(isOpenBox);

        if (isOpenBox === false) {
            if (props.existInformation) {
                if (props.params.responsavel || props.params.crea || props.params.art) {
                    if (props.params.responsavel === '') {
                        setErroResp(true);
                        props.updateError(true);
                    } else {
                        setErroResp(false);
                    }

                    if (props.params.crea === '') {
                        setErroCrea(true);
                        props.updateError(true);
                    } else {
                        setErroCrea(false);
                    }

                    if (props.estado.value != 'RJ') {
                        if (props.params.art === '') {
                            setErroArt(true);
                            props.updateError(true);

                        } else {
                            setErroArt(false);
                        }
                    }
                }
            }
        }
    },[isOpenBox])

    useEffect(() => {
        if (props.isOpen != isOpenBox) {
            setIsOpenBox(props.isOpen);
        }
    },[props.isOpen])

    return (
        <Container>
            <FormContainer>
                <Card className="step02" existInformation={props.existInformation} onClick={() => openBoxAgronomo2()} openBox={isOpenBox} disabled={props.disabled} erro={ erroResp === true || erroCrea === true || erroArt === true ? true : props.error}>
                    <div className="row">
                        <H6 color={props.disabled ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}>
                            Responsável Técnico
                        </H6>

                        {!props.disabled ? (
                            <img className="arrow" src={ArrowIcon} alt='arrow' onClick={() => openBoxAgronomo()}/>
                        ) : (
                            <img className="arrow" src={ArrowIcon} alt='arrow'/>   
                        )}
                    </div>

                    {!props.existInformation ? (
                        <>
                            {!isOpenBox ? (
                                <Paragraph disabled={props.disabled}>Insira o Nome, Número do CREA ou CFTA, da ART ou TRT e escolha o tipo de assinatura: Digital, Eletrônica ou Manual.</Paragraph>
                            ) : (
                                <ContainerForm>
                                    <FormAgronomo 
                                        estado={props.estado}
                                        dataEmissao={props.dataEmissao}
                                        update={(value) => updateValues(value)}
                                        producerData={props.producerData}
                                        recipeDraft={props.recipeDraft}
                                    />
                                </ContainerForm>
                            )}

                        </>
                    ) : (
                        <>
                            {!isOpenBox ? (
                                <>
                                    <RowInfo>
                                        <ColInfo>
                                            <TaglineP color={
                                                props.disabled ? theme.colors.disabled.Desabilitado_Medio : 
                                                erroResp === true ? theme.colors.red.Vermelho_erro : 
                                                props.params.erroResponsavel ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_2}
                                                >
                                                Técnico
                                            </TaglineP>

                                            <S.ContainerInfoText 
                                                bgColor={theme.colors.gray.Cinza_11}
                                                erro={erroResp === true ? erroResp : props.params.erroProdutor} disabled={props.disabled}
                                                >
                                                    <img src={responsavel} alt='Ícone de responsável' style={{ width: "16px", height: "auto" }}/>
                                                    
                                                    <TaglinePSpan color={theme.colors.gray.Cinza_2}>
                                                        {props.params.responsavel.label}
                                                    </TaglinePSpan>
                                            </S.ContainerInfoText>

                                            {/* <Texto erro={erroResp === true ? erroResp : props.params.erroResponsavel} disabled={props.disabled}></Texto> */}
                                        </ColInfo>

                                        <ColInfo>
                                            <TaglineP color={
                                                props.disabled ? theme.colors.disabled.Desabilitado_Medio : 
                                                erroCrea === true ? theme.colors.red.Vermelho_erro : 
                                                props.params.erroProdutor ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_2}
                                                >
                                                CREA/VISTO/CFTA
                                            </TaglineP>

                                            {/* <Label erro={erroCrea === true ? erroCrea : props.params.erroCrea} disabled={props.disabled}></Label> */}
                                            
                                            <BodyPSpan color={
                                                erroCrea === true ? theme.colors.red.Vermelho_erro : 
                                                props.params.erroCrea ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_2}
                                                >
                                                {props.params.crea.label}
                                            </BodyPSpan>

                                            {/* <Texto erro={erroCrea === true ? erroCrea : props.params.erroCrea} disabled={props.disabled}>{props.params.crea.label}</Texto> */}
                                        </ColInfo>

                                        {props.estado.value != 'RJ' ? (
                                            <ColInfo>
                                                <TaglineP color={
                                                    props.disabled ? theme.colors.disabled.Desabilitado_Medio : 
                                                    erroArt === true ? theme.colors.red.Vermelho_erro : 
                                                    props.params.erroArt ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_2}
                                                    >
                                                    ART/TRT
                                                </TaglineP>

                                                <BodyPSpan color={
                                                    erroArt === true ? theme.colors.red.Vermelho_erro : 
                                                    props.params.erroCrea ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_2}
                                                    >
                                                    {props.params.art.label}
                                                </BodyPSpan>

                                                {/* <Label erro={erroArt === true ? erroArt : props.params.erroArt} disabled={props.disabled}></Label> */}
                                                {/* <Texto erro={erroArt === true ? erroArt : props.params.erroArt} disabled={props.disabled}></Texto> */}
                                            </ColInfo>
                                        ) : (null)}

                                        <ColInfo>
                                                <TaglineP color={
                                                    props.disabled ? theme.colors.disabled.Desabilitado_Medio : 
                                                    props.params.erroAssinatura ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_2}
                                                    >
                                                    Assinatura
                                                </TaglineP>

                                                <BodyPSpan color={
                                                    props.params.erroAssinatura ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_2}
                                                    >
                                                    {props.params.assinatura.label}
                                                </BodyPSpan>

                                            {/* <Label erro={props.params.erroAssinatura} disabled={props.disabled}>Tipo de assinatura preferencial</Label> */}
                                            {/* <Texto erro={props.params.erroAssinatura} disabled={props.disabled}></Texto> */}
                                        </ColInfo>
                                    </RowInfo>
                                </>
                            ) : (
                                //formulário
                                <ContainerForm>
                                    <FormAgronomo 
                                        estado={props.estado}
                                        dataEmissao={props.dataEmissao}
                                        update={(value) => updateValues(value)}
                                        params={props.params}
                                        producerData={props.producerData}
                                        recipeDraft={props.recipeDraft}
                                        inicialDateReceita={props.inicialDateReceita}
                                    />
                                </ContainerForm>
                            )}
                        </>
                    )}
                </Card>
            </FormContainer>
        </Container>
    )
};

export default PrescriptionStepThree;